module.exports = __webpack_public_path__ + "static/React_Balloon-f00fcca1b373d33ae200ab89f9628b57.png";